import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact'
import { useState, useRef } from 'preact/hooks'
import { closeSiblingFacets } from '../helpers'

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)
    const buttonRef = useRef(null)

    // Generate marks for the slider
    const generateMarks = () => {
        const marks = []
        const totalMarks = 35
        const valueRange = max - min

        for (let i = 0; i < totalMarks; i++) {
            const percent = i / (totalMarks - 1)
            const value = Math.round(min + percent * valueRange)
            const isMidPoint = i === Math.floor(totalMarks / 2)
            const isMinOrMax = i === 0 || i === totalMarks - 1
            marks.push({
                value,
                label: isMinOrMax || isMidPoint ? value.toString() : '',
                percent: percent * 100,
                isMidPoint,
                isMinOrMax,
            })
        }

        return marks
    }

    const marks = generateMarks()

    const handleToggle = (e) => {
        closeSiblingFacets(buttonRef.current)
    }

    return (
        <div class="collection-sidebar__group">
            <button
                ref={buttonRef}
                type="button"
                class="collapsible-trigger collapsible-trigger-btn collapsible--auto-height close-siblings tag-list__header"
                aria-controls={facet.id}
                aria-expanded="false"
                onClick={handleToggle}>
                {facet.name}
                <svg
                    role="presentation"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9 18L15 12L9 6"
                        stroke="#f4762d"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </button>
            <div id={facet.id} class="collapsible-content collapsible-content--sidebar" style="height: 0px">
                <div class="collapsible-content__inner">
                    <div class="slider-with-marks-container">
                        <RangeSlider id={facet.id} />
                        <div class="slider-marks">
                            {marks.map((mark) => (
                                <div class="slider-mark" style={`left: ${mark.percent}%;`}>
                                    <div
                                        class={`mark-tick ${
                                            mark.isMinOrMax || mark.isMidPoint
                                                ? 'mark-tick--large'
                                                : 'mark-tick--small'
                                        }`}></div>
                                    {mark.label && <div class="mark-label">{mark.label}</div>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
